var oddConversion = function() {

    var convert_odd_to_proba = function() {
        var odd = Generic.parseNumericInput($('#odd').val());

        if (odd < 1) {
            $('#ocform').addClass('was-validated');
            $('#proba').val('');
        } else {
            var proba = 100 / odd;
            $('#proba').val(proba.toFixed(2));
        }
    };

    var convert_proba_to_odd = function() {
        var proba = $('#proba').val().replace('%', '');
        proba = Generic.parseNumericInput(proba);

        if (proba <= 0) {
            $('#ocform').addClass('was-validated');
            $('#odd').val('');
        } else {
            var odd = 100 / proba;
            $('#odd').val(odd.toFixed(2));
        }
    };

    var remove_valid_style = function() {
        if ($('#ocform')[0].checkValidity()) {
            $('.ii__form_input').css('border-color', '#d8d8d8');
            $('.ii__form_input').css('background-image', 'none');
        } else {
            $('.ii__form_input').css('border-color', '');
            $('.ii__form_input').css('background-image', '');
        }
    };

    return {
        init: function() {
            $('.ii__form_input').val('');
            $('#ocform').removeClass('was-validated');

            $('#proba_btn').on('click', function(){
                convert_odd_to_proba();
                remove_valid_style();
            });
            $('#odd_btn').on('click', function(){
                convert_proba_to_odd();
                remove_valid_style();
            });
        }
    };
}();
